export default __webpack_public_path__ + "static/media/KISA_logo_basic.9a7f6d20.svg";